import React, { FC } from 'react'

import { ActionButtonProps } from '../ActionButton'
import { IconProps } from '../Icon'

import * as SC from './styled'

export type BannerProps = {
  className?: string
  title: string
  headerButton?: ActionButtonProps
  icon?: IconProps
  headerFaqButton?: ActionButtonProps
}

const Banner: FC<BannerProps> = (props) => {
  const { className, title, headerButton, headerFaqButton, icon } = props

  return (
    <SC.Container className={className}>
      {headerButton && <SC.Button {...headerButton} noTextOnMobile />}
      <SC.Title>
        {title}
        {icon && <SC.StyledIcon {...icon} />}
      </SC.Title>
      {headerFaqButton && <SC.FaqButton {...headerFaqButton} noTextOnMobile />}
    </SC.Container>
  )
}

export default Banner
